import { render, staticRenderFns } from "./Boletin.vue?vue&type=template&id=246baeae&scoped=true"
import script from "./Boletin.vue?vue&type=script&lang=js"
export * from "./Boletin.vue?vue&type=script&lang=js"
import style0 from "./Boletin.vue?vue&type=style&index=0&id=246baeae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246baeae",
  null
  
)

export default component.exports